module.exports = __webpack_public_path__ + "static/media/hepatica-pair.9a11bed3.jpg";